import { Injectable, signal, computed } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum VideoLayout {
  SINGLE = 1,
  SIDE_BY_SIDE = 2,
  LARGE_LEFT = 3,
  LARGE_RIGHT = 4,
  GRID_2X2 = 5,
  STACKED = 6,
}

export interface LayoutConfig {
  id: VideoLayout;
  label: string;
  playerCount: number;
}

const LAYOUT_CONFIGS: Record<VideoLayout, LayoutConfig> = {
  [VideoLayout.SINGLE]: { id: VideoLayout.SINGLE, label: 'Single View', playerCount: 1 },
  [VideoLayout.SIDE_BY_SIDE]: {
    id: VideoLayout.SIDE_BY_SIDE,
    label: 'Side by Side',
    playerCount: 2,
  },
  [VideoLayout.LARGE_LEFT]: { id: VideoLayout.LARGE_LEFT, label: 'Large Left', playerCount: 3 },
  [VideoLayout.LARGE_RIGHT]: { id: VideoLayout.LARGE_RIGHT, label: 'Large Right', playerCount: 3 },
  [VideoLayout.GRID_2X2]: { id: VideoLayout.GRID_2X2, label: '2×2 Grid', playerCount: 4 },
  [VideoLayout.STACKED]: { id: VideoLayout.STACKED, label: 'Stacked', playerCount: 2 },
};

@Injectable({ providedIn: 'root' })
export class VideoLayoutService {
  public activeLayout$ = new BehaviorSubject<VideoLayout>(VideoLayout.SINGLE);

  public getLayoutConfig() {
    return LAYOUT_CONFIGS[this.activeLayout$.value];
  }

  public getPlayerCount(): number {
    return this.getLayoutConfig().playerCount;
  }

  public setLayout(layout: VideoLayout): void {
    this.activeLayout$.next(layout);
  }

  public isLayout(layout: VideoLayout): boolean {
    return this.activeLayout$.value === layout;
  }
}
